import { get } from 'lodash';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { PaginationResponse } from 'services/commonTypes';
import { IApiGetPlaylistParam, IPlaylist } from '../interfaces/api';
/**
 * please change reducer name
 */
// @ts-ignore
type MyState = RootState['playlist']; // ex: RootState['booking']
// @ts-ignore
const getCurrentState = (state: RootState): MyState => state['playlist']; // ex: state['booking']

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector(state => get(getCurrentState(state), key, defaultValue));

const getDemoData = () => selector('demoData') as IDEMOModelResDataItem[];

const getListPlaylists = () => selector('dataPlaylists') as PaginationResponse<IPlaylist> | null;
const getPlaylistsParam = () => selector('playlistsParam') as IApiGetPlaylistParam;

/**
 * please replace channel to your feature name
 * ex:
 * playlistSelectors => bookingSelectors
 */
const playlistSelectors = {
  getDemoData,
  getListPlaylists,
  getPlaylistsParam,
};
export default playlistSelectors;
